<template>
    <div class="box">
        <el-table
          :data="orderList"
          row-key="kkOrderId"
          height="100%"
          :key="tableKey">
          <el-table-column
            v-if="showColumns.includes('平台/店铺')"
            label="平台/店铺"
            min-width="200"
            align="center">
            <template slot-scope="scope">
              <div class="tablePlatformLogo">
                <img v-if="scope.row.platformCode === 'KA'" src="@/assets/img/platform-logo/kakaclo.png" >
                <img v-if="scope.row.platformCode === 'SP'" src="@/assets/img/platform-logo/shopify.png" >
                <img v-if="scope.row.platformCode === 'DJ'" src="@/assets/img/platform-logo/shoplazza.png" >
                <img v-if="scope.row.platformCode === 'SL'" src="@/assets/img/platform-logo/shopline.png" >
                <img v-if="scope.row.platformCode === 'WC'" src="@/assets/img/platform-logo/woocommerce.png" >
                <img v-if="scope.row.platformCode === 'TT'" src="@/assets/img/platform-logo/tiktok.png" >
              </div>
              <div>{{scope.row.storeName}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="kkOrderId"
            label="kaka订单号"
            min-width="200">
                <template slot-scope="scope">
                    <!-- <copy :text="scope.row.kkOrderId" @click="viewDetails(scope.row)" style="color: #99C41C" class="pointer"></copy> -->
                    <div class="kkOrderIdCopy">
                        <span class="ellipsis pointer" style="display: inline-block; color: #99C41C" :title="scope.row.kkOrderId" v-text="scope.row.kkOrderId" @click="viewDetails(scope.row)"  />
                        <i class="pointer iconfont el-icon-document-copy" @click="copy(scope.row.kkOrderId)" />
                    </div>
                    <div>
                        <i class="el-icon-edit pointer" style="font-size: 16px" v-if="scope.row.isNote === 0" @click="$refs.remarkDialog.show(scope.row)"></i>
                        <i class="el-icon-chat-dot-square pointer" style="font-size: 16px" v-else @click="$refs.remarkDialog.show(scope.row)"></i>
                    </div>
                </template>
          </el-table-column>
          <el-table-column
            label="商品信息"
            min-width="280">
            <template slot-scope="scope">
              <productImages :orderItems="scope.row.orderItems" :order="scope.row" @batchOutOfStockSubmit="$emit('batchOutOfStockSubmit')"></productImages>
            </template>
          </el-table-column>
          <template v-for="column in showColumns">
            <el-table-column prop="brandName" label="商标名称" v-if="column === '商标名称'" :key="column" align="center" min-width="100">
          </el-table-column>
            <el-table-column prop="address" label="总金额" v-if="column === '总金额'" :key="column" align="center" min-width="120">
                <template slot-scope="scope">
                    USD {{ scope.row.totalAmount }}
                </template>
            </el-table-column>
            <el-table-column prop="payDate" label="付款时间" v-if="column === '付款时间'" :key="column" align="center"  min-width="200">
                <template slot-scope="scope">
                    {{ scope.row.payDate ? getMoment(scope.row.payDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}
                </template>
            </el-table-column>
            <el-table-column prop="createDate" label="创建时间" v-if="column === '创建时间'" :key="column" min-width="200" align="center">
                <template slot-scope="scope">
                    {{ getMoment(scope.row.createDate).format('YYYY-MM-DD HH:mm:ss')}}
                </template>
            </el-table-column>
            <el-table-column prop="customer" label="客户名称" v-if="column === '客户名称'" :key="column" align="center" min-width="140">
            </el-table-column>
            <el-table-column prop="email" label="客户邮箱" v-if="column === '客户邮箱'" :key="column" align="center" min-width="200">
            </el-table-column>
            <el-table-column label="订单状态" v-if="column === '订单状态'" :key="column" align="center" min-width="140">
                <template slot-scope="scope">
                    {{ orderStauts(scope.row) }}
                </template>
            </el-table-column>
            <el-table-column prop="storeOrderId" label="第三方平台单号" v-if="column === '第三方平台单号'" :key="column" align="center" min-width="200">
            </el-table-column>
            <el-table-column prop="transactionId" label="第三方支付单号" v-if="column === '第三方支付单号'" :key="column" align="center" min-width="200">
            </el-table-column>
            <el-table-column prop="paymentId" label="Payment ID" v-if="column === 'Payment ID'" :key="column" align="center" min-width="200">
            </el-table-column>
            <el-table-column prop="couponCode" label="优惠码" v-if="column === '优惠码'" :key="column" align="center" min-width="80">
            </el-table-column>
            <el-table-column prop="inviteCode" label="推广码" v-if="column === '推广码'" :key="column" align="center" min-width="80">
            </el-table-column>
            <el-table-column prop="channelCode" label="物流渠道编码" v-if="column === '物流渠道编码'" :key="column" align="center" min-width="120">
            </el-table-column>
            <el-table-column prop="channelName" label="渠道名称" v-if="column === '渠道名称'" :key="column" align="center" min-width="100">
            </el-table-column>
            <el-table-column prop="channelLevel" label="物流等级" v-if="column === '物流等级'" :key="column" align="center" min-width="120">
            </el-table-column>
            <el-table-column prop="recipient" label="收货人" v-if="column === '收货人'" :key="column" align="center" min-width="140">
            </el-table-column>
            <el-table-column prop="country" label="收货国家" v-if="column === '收货国家'" :key="column" align="center" min-width="100">
            </el-table-column>
            <el-table-column prop="province" label="省州" v-if="column === '省州'" :key="column" align="center" min-width="60">
            </el-table-column>
            <el-table-column prop="city" label="城市" v-if="column === '城市'" :key="column" align="center" min-width="60">
            </el-table-column>
            <el-table-column prop="street1" label="地址信息1" v-if="column === '地址信息1'" :key="column" align="center" min-width="180">
            </el-table-column>
            <el-table-column prop="street2" label="地址信息2" v-if="column === '地址信息2'" :key="column" align="center" min-width="180">
            </el-table-column>
            <el-table-column prop="zip" label="邮编" v-if="column === '邮编'" :key="column" align="center" min-width="80">
            </el-table-column>
            <el-table-column prop="phone" label="电话" v-if="column === '电话'" :key="column" align="center" min-width="180">
            </el-table-column>
            <el-table-column prop="showName" label="邮箱/手机号" v-if="column === '邮箱/手机号'" :key="column" align="center" min-width="220">
            </el-table-column>
            <el-table-column prop="totalAmount" label="订单总金额" v-if="column === '订单总金额'" :key="column" align="center" min-width="120">
            </el-table-column>
            <el-table-column prop="couponAmount" label="优惠码金额" v-if="column === '优惠码金额'" :key="column" align="center" min-width="120">
            </el-table-column>
            <el-table-column prop="couponTicketAmount" label="优惠券金额" v-if="column === '优惠券金额'" :key="column" align="center" min-width="120">
            </el-table-column>
            <el-table-column prop="freightAmount" label="运费" v-if="column === '运费'" :key="column" align="center" min-width="60">
            </el-table-column>
            <el-table-column prop="discountAmount" label="折扣总金额" v-if="column === '折扣总金额'" :key="column" align="center" min-width="120">
            </el-table-column>
            <el-table-column prop="weightSum" label="SKU总重量" v-if="column === 'SKU重量'" :key="column" align="center" min-width="100">
            </el-table-column>
            <el-table-column prop="remark" label="买家留言" v-if="column === '买家留言'" :key="column" align="center" min-width="120">
            </el-table-column>
          </template>
          <el-table-column label="操作" min-width="140" align="center">
            <template slot-scope="scope">
                <el-button type="text" @click="viewDetails(scope.row)">View Details</el-button>
                <el-button type="text" @click="showDialog(scope.row)" v-if="scope.row.cancelFulfillmentStatus === 'cancellation_requested'">{{ confirmButtonText }}</el-button>
                <el-popconfirm v-if="+scope.row.paymentMethod === 8 && ['fully_shipped', 'partial_shipped', 'completed'].includes(scope.row.fulfillmentStatus)" title="订单存在未发货产品，你确认要上传发票到40seas？" @confirm="uploadInvoice(scope.row)">
                    <el-button slot="reference" type="text">Upload Invoice</el-button>
                </el-popconfirm>
                
            </template>
          </el-table-column>
        </el-table>
        <remarkDialog ref="remarkDialog" @refresh="$emit('refresh')"></remarkDialog>
        <el-dialog title="Cancel Delivery" :visible.sync="cancellationVisible" :close-on-click-modal="false">
            <div style="font-size: 16px; line-height:40px">
                Do you agree with the shopify seller to cancel the shipping application?
            </div>
            <div style="font-size: 14px; line-height:40px"> 
                After agreeing to the seller's cancellation of the delivery application, if there is no need for kaka delivery, please intercept it in time.
            </div>
            <div slot="footer" class="f-e">
                <el-button type="primary" @click="accept(true)">Agree</el-button>
                <el-button @click="accept(false)">Reject</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import productImages from './productImages.vue'
import moment from 'moment'
import API from '@/api'
// import copy from '@/components/copy.vue'
import { copy } from '@/utils'
import remarkDialog from './remarkDialog.vue'

export default {
    props: {
        orderList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showColumns: ['总金额', '付款时间', '创建时间', '客户名称', '客户邮箱', '订单状态'],
            tableKey: moment().valueOf(),
            viewPortHeight: 0,

            loading: false,
            cancellationVisible: false,
            confirmButtonText: 'Cancel Deliver',
            showConfirmButton: true,
            cancellationData: {}
        }
    },
    components: {
        productImages,
        remarkDialog
        // copy
    },
    computed: {
        getMoment() {
            return moment
        }
    },
    mounted() {
        const that = this
        this.viewPortHeight = window.innerHeight - 400
        window.onresize = () =>{
            that.viewPortHeight = window.innerHeight - 400
            // console.log(that.viewPortHeight)
        }
    },
    methods: {
        changeShowColumns(columns) {
            this.showColumns = columns
            this.$nextTick(()=>{
                this.tableKey = moment().valueOf()
            })
        },
        viewDetails(row) {
            // console.log(row)
            this.$router.push(`/orders/all-orders/order-details?id=${row.kkOrderId}`)
        },
        getBehaviorConfig() {
            API.getBehaviorConfig(1).then(res=>{
                // console.log(res)
            })
        },
        orderStauts(row) {
            let status = ''
            if (['waiting_payment', 'completed', 'cancel'].includes(row.status)) status = row.status
            if (row.status === 'abnormal_order') status = row.status
            if (row.status === 'processing') status = row.fulfillmentStatus
            const statusMap = {
                waiting_payment: 'Waiting payment',
                completed: 'Complete',
                cancel: 'Cancel',
                waiting_to_ship: 'Waiting to Ship',
                fully_shipped: 'Fully Shipped',
                partial_shipped: 'Partial Shipped',
                refunding: 'Refunding',
                partial_refund: 'Partial Refund',
                refunded: 'Refunded',
                abnormal_order: 'Abnormal Order'
            }
            return statusMap[status]
        },
        copy,
        orderGetRemark(row) {},

        showDialog(row) {
            this.cancellationData = row
            this.cancellationVisible = true
        },
        accept(accept) {
            // 处理取消交运请求逻辑
            this.showModal = true
            let form = {
                storeId: this.cancellationData.storeId,
                storeOrderId: this.cancellationData.storeOrderId,
                accept
            }
            API.orderCancelFulfillment(form)
            .then((res) => {
                if (res.code === 10000) {
                    this.cancellationVisible = false
                    // 子组件传父组件
                    this.$emit('refresh')
                    this.$message.success('success')
                    this.handleClose()
                    this.$emit('submit')
                } else {
                    this.$message.error(res.message)
                }
                
            })
        },
        uploadInvoice(row) {
            API.uploadInvoice40seas(row.kkOrderId).then(res => {
                if (res.code !== 10000) return this.$message.error(res.message)
                this.$message.success('uploaded success')
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.box{
    height: calc(100vh - 400px);
}
.tablePlatformLogo{
    >img{
        width: 30px;
        height: 30px;
    }
}
.kkOrderIdCopy{
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
}
.el-icon-document-copy{
  margin-left: 2px;
//   color: blue
}
.kkOrderIdCopy:hover > .el-icon-document-copy{
  color: #99C41C;
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 4px;
}
</style>
